import { render, staticRenderFns } from "./ComponentCard.vue?vue&type=template&id=784a3bcc&scoped=true"
import script from "./ComponentCard.vue?vue&type=script&lang=js"
export * from "./ComponentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a3bcc",
  null
  
)

export default component.exports